import Button, { ButtonProps } from '@portalterreno/react-ui-core/Button';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';

export type ContactSubmitButtonProps = Omit<
  ButtonProps,
  'fullWidth' | 'onClick' | 'type' | 'loading' | 'disabled'
> & {
  onSubmit: () => void;
};

const ContactSubmitButton: React.FC<ContactSubmitButtonProps> = ({
  onSubmit,
  ...rest
}) => {
  const { t } = useTranslation('property');

  const state = useSelector(
    (state: RootState) => ({
      isContactButtonLoading: state.contactForm.isContactButtonLoading,
      isContactFormSent: state.contactForm.isContactFormSent,
      isValidMessage: state.contactForm.isValidMessage,
      isWhatsappButtonLoading: state.contactForm.isWhatsappButtonLoading
    }),
    shallowEqual
  );

  const buttonText = t('contact');

  return (
    <Button
      {...rest}
      fullWidth
      onClick={onSubmit}
      type='submit'
      loading={state.isContactButtonLoading}
      disabled={
        state.isContactFormSent ||
        state.isWhatsappButtonLoading ||
        !state.isValidMessage
      }
    >
      {buttonText}
    </Button>
  );
};

export default ContactSubmitButton;
